import { Injectable } from '@angular/core';
import { listLocales } from 'ngx-bootstrap/chronos';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { esLocale } from 'ngx-bootstrap/locale';


@Injectable()
export class UtilitiesService {
  locale = esLocale;
  locales = listLocales();
  private _isIE: boolean;
  private _isEdge: boolean;
  private _isFirefox: boolean;

  constructor(private localeService: BsLocaleService) {
    // this.localeService.use('es');
    this._isIE = /*@cc_on!@*/false || !!(<any>document).documentMode;
    this._isEdge = !this._isIE && !!(<any>window).StyleMedia;
    this._isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  }


  getDatepickerConfig(): BsDatepickerConfig {
    return Object.assign(new BsDatepickerConfig(), {
      locale: localStorage.getItem('idioma'),
      adaptivePosition: true,
      containerClass: 'theme-blue',
      showWeekNumbers: false,
      dateInputFormat: 'DD-MM-YYYY',
      startingDay: 1
    });
  }

  downloadGenericFile(fileName: string, data: any) {
    const blob = new Blob([data], { type: 'application/octet-stream' });
    let objectUrl = '';
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      // save file for IE
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
      // save for other browsers: Chrome, Firefox
      objectUrl = URL.createObjectURL(blob);
      // window.open(objectUrl);
      a.href = objectUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    }
  }

  downloadDataInCSV(fileName: string, data: string) {
    const aElement = document.createElement('a');
    if (navigator.msSaveBlob) { // IE11 es necesario añadir BOM previo a los datos
      const blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), data], {
        type: 'application/octet-stream'
      });
      console.log(data);
      navigator.msSaveBlob(blob, fileName);
    } else if (URL && 'download' in aElement) {
      //aElement.setAttribute('href', 'data:text/csv;charset=utf-8,\uFEFF' + encodeURI(data));
      aElement.setAttribute('href', 'data:text/csv;charset=ANSI,\uFEFF' + encodeURI(data));
      aElement.setAttribute('download', fileName);
      document.body.appendChild(aElement);
      aElement.click();
      document.body.removeChild(aElement);
    } else {
      location.href = 'data:application/octet-stream,' + encodeURI(data); // only this mime type is supported
    }

  }

  downloadDataInPDF(fileName: string, data: ArrayBuffer) {
    const aElement = document.createElement('a');
    const blobObject = new Blob([data], { type: 'application/pdf' });
    if (navigator.msSaveBlob) { // IE10
      window.navigator.msSaveOrOpenBlob(blobObject, fileName);
    } else if (URL && 'download' in aElement) {
      const downloadLink = document.createElement('a');
      downloadLink.style.display = 'none';
      document.body.appendChild(downloadLink);
      downloadLink.setAttribute('href', URL.createObjectURL(blobObject));
      downloadLink.setAttribute('download', fileName);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }

  isIE(): boolean {
    return this._isIE;
  }

  isEdge(): boolean {
    return this._isEdge;
  }

  isFirefox(): boolean {
    return this._isFirefox;
  }


}
